import { useQuery } from "@tanstack/react-query";
import DOMPurify from "dompurify";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { fetchContentById } from "../../behavior/api/content";
import HeadingAndImageSection from "../../components/article/HeadingAndImageSection";
import { Button, Text } from "../../components/elements";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import { PageRoute } from "../../constants";
import { getLocalDate } from "../../utils/dateUtilities";
import "./Article.css";

const Article = () => {
    const { t } = useTranslation();
    const params = useParams<{ id: string }>();
    const {
        data: content,
        isLoading: loading,
        error,
    } = useQuery({
        queryKey: ["content", params.id],
        queryFn: fetchContentById(params.id),
        enabled: !!params.id,
    });

    return (
        <>
            <Header type="LoggedIn" />
            <div className="article-page-wrapper">
                <Button secondary link to={PageRoute.LEARN_WITH_HUBERT} className="back-button">
                    <ArrowLeft size={20} className="me-2 rtl:-scale-x-100" />
                    <div>{t("Article.ButtonText_BackToAllArticles")}</div>
                </Button>
                {error || !content ? (
                    loading ? null : (
                        <>No Content Found</>
                    )
                ) : (
                    <>
                        <HeadingAndImageSection
                            tag={content.primaryTag}
                            headingText={content.title}
                            image={content.featureImage}
                            author={content.primaryAuthor}
                            datePosted={getLocalDate(content.publishedOn)}
                            loading={loading}
                        />
                        <div className="article-content-section">
                            <Text block html loading={loading}>
                                {DOMPurify.sanitize(content.html ?? "")}
                            </Text>
                        </div>
                    </>
                )}
            </div>
            <Footer />
        </>
    );
};

export default Article;
